<script setup lang="ts">
import { Badge } from '@/components/ui/badge'
import { sideConfig } from '@/lib/product'

defineProps<{
    side: 'resell' | 'buyback'
}>()
</script>

<template>
    <Badge :variant="sideConfig[side].variant" class="shrink-0 gap-1">
        <component :is="sideConfig[side].icon" class="size-3" />
        {{ sideConfig[side].label }}
    </Badge>
</template>
